// Host-owned notifications feed client (ADR-0014).
//
// The design system stays data-blind; shell owns the feed hooks and talks to the
// notification service through the auth BFF so the browser never sees a JWT.

import { createNotificationBrowserClient } from "@playbookai/notification-client/browser";
import type { NotificationsApi } from "@playbookai/notification-client/browser";
import { getCsrfToken } from "../auth/session-api.js";
import { getRuntimeConfig } from "../config/runtime.js";

export type { NotificationsApi };

export const notificationsApi: NotificationsApi =
  createNotificationBrowserClient({
    baseUrl: getRuntimeConfig().api.notificationBaseUrl,
    useCookies: true,
    // Mark-read and read-all are POSTs through the BFF, which enforces CSRF on
    // every unsafe method. `buildHeaders` only sets `x-csrf-token` when a getter
    // is supplied, so without this both write routes answer 403 — the feed still
    // reads fine, which is why the bell looks healthy but nothing can be marked.
    getCsrfToken,
  });
